import ServiceTypeEnum from "@/config/serviceTypeEnum"
import { ServiceQuote } from "@requests"
import { OptionTypeEnum } from "../../../requests-module/src"


const getFamilyTypeForQuoteObject = (anyQuoteObj: ServiceQuote) => {
    if (anyQuoteObj.travellers) return ServiceTypeEnum.Participant
    if (anyQuoteObj.quantitySelected || anyQuoteObj.serviceType === OptionTypeEnum.ACCOMODATION) return ServiceTypeEnum.Accomodation
    return ServiceTypeEnum.Global
}

export default getFamilyTypeForQuoteObject